import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'polaris-ideas.view-content.idea-list.row.add-idea-input.placeholder',
		defaultMessage: 'Add a quick summary of your idea and press enter',
		description: 'Placeholder message visible when adding an idea.',
	},
});
